import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Step } from '../../models/Step';

export interface WarrantyOptionConfigModel {
  id: string;
  title: string;
  price: string;
}

type TPayload = {
  steps: Step[];
};

export type InsuranceState = {
  insuranceLoading: {
    isLoading: boolean;
    stepKey?: string;
    requestKey?: string;
  };
  insuranceEnabled: boolean;
  reviewInsuranceObject: any;
  warranty?: WarrantyOptionConfigModel;
  pricingMethodConfig: any;
};

const initialState: InsuranceState = {
  insuranceLoading: {
    isLoading: false,
  },
  insuranceEnabled: false,
  reviewInsuranceObject: null,
  pricingMethodConfig: undefined,
};

const insuranceSlice = createSlice({
  name: 'insurance',
  initialState: initialState,
  reducers: {
    setInsuranceEnabled: (state, { payload }: PayloadAction<boolean>) => {
      state.insuranceEnabled = payload;
    },
    setInsuranceLoading: (
      state,
      { payload }: PayloadAction<InsuranceState['insuranceLoading']>
    ) => {
      if (
        payload.stepKey &&
        state.insuranceLoading?.stepKey &&
        payload.stepKey === state.insuranceLoading.stepKey &&
        state.insuranceLoading.isLoading
      ) {
        console.log(
          'RXC3 | spengo insuranceLoading in step: ',
          payload.stepKey
        );
        state.insuranceLoading = {
          isLoading: false,
        };
      } else {
        if (!state.insuranceLoading.isLoading && payload.isLoading) {
          console.log(
            'RXC3 | accendo insuranceLoading in step: ',
            payload.stepKey
          );
          state.insuranceLoading.isLoading = true;
        }
        if (payload.isLoading) state.insuranceLoading.stepKey = payload.stepKey;
      }
    },
    setReviewInsuranceObject: (state, { payload }: PayloadAction<any>) => {
      state.reviewInsuranceObject = {
        ...payload,
      };
    },
    setPricingMethodConfig: (state, { payload }: PayloadAction<any>) => {
      state.pricingMethodConfig = payload;
    },
    setWarranty: (
      state,
      { payload }: PayloadAction<WarrantyOptionConfigModel>
    ) => {
      state.warranty = payload;
    },
    reset: (state) => {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key];
      });
    },
  },
});

export const insuranceReducer = insuranceSlice.reducer;
export const insuranceActions = insuranceSlice.actions;
